export enum enumLoginTokenAction {
    mostraEstagio = 7,
    cadastraEstagioObrigatorio = 12,
    cadastraEstagioNaoObrigatorio = 13,
    painel = 14
}